<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_TITLE" ppColor="primary-950"></pp-icon>
</div>

<span>
  <span class="notification__blue-text">{{ 'changed' | ppTranslate }}</span>
  {{ 'the' | ppTranslate }}
  <span class="notification__bold">{{ 'title' | ppTranslate }}</span>
  {{ 'of_a_point_you' | ppTranslate }}
  {{ notificationReason }}:
</span>

<div>"{{ ppNotification.changeBody.newValue }}"</div>
